import parcelRepository from '@/domain/repository/ParcelRepository';
import {Parcel} from '@/domain/entities/Parcel';

export const getParcelsByProject = async (projectUuid: string): Promise<Array<Parcel>> => {
  try {
    return parcelRepository.getParcelsByProject(projectUuid);
  } catch (error) {
    console.error('Error fetching parcels', error);
    return [];
  }
};